// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SideWidgetAssessments_wrapper","widget-card":"SideWidgetAssessments_widget-card","widgetCard":"SideWidgetAssessments_widget-card"};